import React, { useState, useEffect, useRef } from 'react';
import './EmailInput.css';
import validate from '../../common/validate';
import baseApi from '../../common/api/base';
import logComponent from '../../common/logComponent';

export default function EmailInput({ initialValue, rules, onValidate, name, label, instructions, showError, errorMessages, readOnly, tabIndex, requireEmailUniqueness }) {
  const [value, setValue] = useState((initialValue ? initialValue : ''));
  const [isValid, setIsValid] = useState(null);
  const [validationDetails, setValidationDetails] = useState(null);
  const [emailUnavailable, setEmailUnavailable] = useState(false);
  const fieldIsValid = isValid; 

  if (logComponent('EmailInput')) { console.debug('EmailInput rendered'); }

  const valueRef = useRef((initialValue ? initialValue : ''));


  const setValueRef = (el) => {
    if (logComponent('EmailInput')) { console.debug('EmailInput setValueRef'); }
    valueRef.current = el;
    setValue(el);
  }

  const validationDetailsRef = useRef(null);


  const setValidationDetailsRef = (el) => {
    if (logComponent('EmailInput')) { console.debug('EmailInput setValidationDetailsRef'); }
    validationDetailsRef.current = el;
    setValidationDetails(el);
  }

  const emailUnavailableRef = useRef(false);


  const setEmailUnavailableRef = (el) => {
    if (logComponent('EmailInput')) { console.debug('EmailInput setEmailUnavailableRef'); }
    emailUnavailableRef.current = el;
    setEmailUnavailable(el);
  }


  useEffect(() => {
    // eslint-disable-next-line react-hooks/exhaustive-deps
    if (logComponent('EmailInput')) { console.debug('EmailInput setNativeCheckboxRef'); }
    validateThis();
  }, []);


  
  const updateValue = (e) => {
    if (logComponent('EmailInput')) { console.debug('EmailInput updateValue'); }
    setEmailUnavailableRef(false);
    setValueRef(e.target.value);
    
  }

  const validateThis = () => {
    if (logComponent('EmailInput')) { console.debug('EmailInput validateThis'); }

    let rulesToCheck = Object.assign({}, rules);

    if (rules.required) {
      rulesToCheck.validEmail = true;
    }
    let validationDetailsLocal = {};

    for (let rule in rulesToCheck) {
      validationDetailsLocal[rule] = validate[rule](valueRef.current, rulesToCheck[rule]);
    }

    let isValidLocal = Object.values(validationDetailsLocal).reduce((prev, curr) => prev && curr, true);

    setValidationDetailsRef(validationDetailsLocal);
    setIsValid(isValidLocal);

    
    checkEmailAvailability();

    onValidate({
      name: name,
      isValid: isValidLocal,
      value: valueRef.current
    });  
  }  

  const handleBlur = () => {
    if (logComponent('EmailInput')) { console.debug('EmailInput handleBlur'); }
    validateThis();
  }

  const checkEmailAvailability = () => {
    if (logComponent('EmailInput')) { console.debug('EmailInput checkEmailAvailability'); }

    // Don't check an invalid email or one that matches that initial email passed in or if email is not required to be unique
    if (!requireEmailUniqueness || valueRef.current == null || (validationDetailsRef.current && !validationDetailsRef.current.validEmail) || valueRef.current === initialValue) return;

    baseApi.User.EmailInUse(valueRef.current)
      .then(result => {
        const inUse = result.data;
        let newValidationDetails = { ...validationDetailsRef.current };
        if (inUse) {
          newValidationDetails.unusedEmail = false;
          setEmailUnavailableRef(true);
        } else {
          newValidationDetails.unusedEmail = true;
          setEmailUnavailableRef(false);
        }

        let isValidLocal = Object.values(newValidationDetails).reduce((prev, curr) => prev && curr, true);
        onValidate({
          name: name,
          isValid: isValidLocal,
          value: valueRef.current
        });  
        setValidationDetailsRef(newValidationDetails);
        setIsValid(isValidLocal);
      });
  }


  return (
    <div className="Email-Input-Group">
    {
      showError && !fieldIsValid &&
      errorMessages.map((message, index) => {
        return <p key={index} className="Email-Input-Group__error">{message.text}</p>;
      })
    }   
      <label 
        className="Email-Input-Group__label"
        htmlFor={name + '-input'}>
              {label}{
        rules && rules.required &&
        <span className="Email-Input-Group__required"> *</span>
}
      </label>
      {
        !(showError && !fieldIsValid) &&
        <span className={'Email-Input-Group__unavailable-error' + (emailUnavailableRef.current ? ' Email-Input-Group__unavailable-error--visible' : '')}>Email address already in use.</span>
      }
      <input 
        id={name + '-input'}
        className="Email-Input-Group__input" 
        type="text"
        spellCheck="false"
        tabIndex={tabIndex}
        readOnly={readOnly}
        value={valueRef.current}
        onChange={updateValue}
        onBlur={handleBlur} />
      { 
        instructions &&
        <span className="Email-Input-Group__instructions">{ instructions }</span>
      }      
    </div>
  );
}